import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_DetachedCommentAnchor = _resolveComponent("DetachedCommentAnchor");
    const _component_ProsemirrorViewerText = _resolveComponent("ProsemirrorViewerText");
    const _component_EditorNodeWrapper = _resolveComponent("EditorNodeWrapper");
    return (_openBlock(), _createBlock(_component_EditorNodeWrapper, {
        class: _normalizeClass([
            'node-container',
            'text-container',
            _ctx.rowTypeClass,
            _ctx.blockWidthClass,
            {
                'parent-first-child': _ctx.parentFirstChild,
                'parent-last-child': _ctx.parentLastChild,
            },
            { 'text-link-node': _ctx.hasLinkNode },
        ]),
        onObserveNodeVisibility: _cache[2] || (_cache[2] = ($event) => (_ctx.$emit('observe-node-visibility', Object.assign(Object.assign({}, $event), { nodeId: _ctx.node.id }))))
    }, {
        default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.commentsWithoutTextSelection, (comment) => {
                return (_openBlock(), _createBlock(_component_DetachedCommentAnchor, {
                    id: comment.id,
                    key: comment.id
                }, null, 8, ["id"]));
            }), 128)),
            _createVNode(_component_ProsemirrorViewerText, {
                content: _ctx.jsonContent,
                "merge-values": _ctx.mergeValues,
                fields: _ctx.fields,
                "default-align": _ctx.defaultAlign,
                "default-heading": _ctx.defaultHeading,
                comments: _ctx.commentsWithTextSelection,
                "selected-comment-id": _ctx.selectedCommentId,
                "show-contextual-comments": _ctx.showContextualComments,
                "create-contextual-comment-button-state": _ctx.createContextualCommentButtonState,
                onCreateComment: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('create-comment', $event))),
                onSelectComment: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('select-comment', $event)))
            }, null, 8, ["content", "merge-values", "fields", "default-align", "default-heading", "comments", "selected-comment-id", "show-contextual-comments", "create-contextual-comment-button-state"])
        ]),
        _: 1
    }, 8, ["class"]));
}
